import { render, staticRenderFns } from "./PostMessages.vue?vue&type=template&id=07cbf91a&scoped=true&"
import script from "./PostMessages.vue?vue&type=script&lang=js&"
export * from "./PostMessages.vue?vue&type=script&lang=js&"
import style0 from "./PostMessages.vue?vue&type=style&index=0&id=07cbf91a&prod&lang=css&"
import style1 from "./PostMessages.vue?vue&type=style&index=1&id=07cbf91a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cbf91a",
  null
  
)

export default component.exports